import { useEffect } from "react";

import isEmpty from "lodash.isempty";
import { useAuth } from "providers/Auth";
import { useShop } from "providers/Shop";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { EventType, sendFBEvent, sendLineTag, sendPageview } from "tracking";

import { findFestivalTagIdBykey, getLandingPageSku } from "pages/utils";
import { CATEGORY_SKU, COLLECTION_SKU } from "utils/shop-settings";

export default function WithTracker({ children, ga, formatter }) {
  const { auth } = useAuth();
  const lineId = auth.userId;
  const params = useParams();
  const gaName = formatter ? formatter(params) : ga;

  useEffect(() => {
    sendPageview(lineId, gaName);
  }, [lineId, gaName]);

  return <>{children}</>;
}

export function WithProductTracker({ children, ga }) {
  const { auth } = useAuth();
  let { id } = useParams();
  const { products } = useShop();
  const lineId = auth.userId;
  const product = products.find((product) => String(product.id) === String(id));

  useEffect(() => {
    if (isEmpty(product)) return;

    const contentGroup1 = `product_id=${product.id}`;
    const contentGroup4 = `${product.name}::${
      product.specs.length === 1 ? product.specs[0].product_spec_uid : "-"
    }`;
    sendPageview(lineId, ga, { contentGroup1, contentGroup4 });
    sendFBEvent(EventType.ViewContent);
    sendLineTag(EventType.ViewItemDetail);
  }, [lineId, ga, product]);

  return <>{children}</>;
}

export function WithIconTracker({ children, ga }) {
  const { auth } = useAuth();
  const { shop, productTags } = useShop();
  let { id } = useParams();
  const lineId = auth.userId;

  const collectionSku = getLandingPageSku(shop, COLLECTION_SKU);

  const findContentById = (id) => {
    const collectionTabs = collectionSku?.blocks;
    const result = collectionTabs.find(
      (collection) =>
        findFestivalTagIdBykey(shop, productTags, collection.key) ===
        Number(id),
    );
    return result || {};
  };

  const title = findContentById(id).title;
  console.log("title", id, title);

  useEffect(() => {
    if (!title) return;

    const contentGroup4 = `${title}`;
    sendPageview(lineId, ga, { contentGroup4 });
  }, [lineId, ga, title]);

  return <>{children}</>;
}

export function WithCategoryTracker({ children, ga }) {
  const { auth } = useAuth();
  let { id } = useParams();
  const intl = useIntl();
  const { shop, categories } = useShop();
  const lineId = auth.userId;
  // const categoryTabs = homeConfig(shop).categories;

  // const category = categoryTabs.find((category) => category.key === id);
  const getIdByKey = (key) => categories.find(({ title }) => title === key)?.id;

  const categorySku = getLandingPageSku(shop, CATEGORY_SKU);
  const categoryTabs = categorySku?.blocks || categories;

  const category = categoryTabs.filter(
    (item) => getIdByKey(item.title) === Number(id),
  )[0];
  const title = category?.title;

  console.log("title", id, title);

  useEffect(() => {
    if (!title) return;

    const contentGroup4 = `${title}`;
    sendPageview(lineId, ga, { contentGroup4 });
  }, [lineId, ga, title]);

  return <>{children}</>;
}
